import { createContext, useContext, useState, useMemo } from 'react';

const MLOContext = createContext();

export const MLOProvider = ({ children }) => {
  const [mloData, setMloData] = useState(null);
  const [isInfluencer, setIsInfluencer] = useState(false);
  const value = useMemo(() => ({ mloData, setMloData, isInfluencer, setIsInfluencer }), [mloData, isInfluencer]);
  return (
    <MLOContext.Provider value={value}>
      {children}
    </MLOContext.Provider>
  );
};

export const useMLO = () => useContext(MLOContext);
